<template>
    <div class="mx-auto container container--fluid">
        <!-- snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- overlay -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- begin -->
        <v-card class="box">
            <v-data-table :headers="headers" :items="query_list" sort-by="name" class="elevation-1 mytable" dense :search="search" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Add Query Type</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"></span>
                    <v-row justify="left" dense>
                        <v-col sm="3" md="3" cols="12"> </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                        </v-col>
                        <span style="width: 20px;"> </span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Query Type</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <!-- {{editedItem}} -->
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.name" persistent-hint label="Enter Query Type"> </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"> </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save">save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <!----------Fetch Table-------------->

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar mr-2">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)" color="success">edit</v-icon>
                        </v-avatar>
                         </div>
                       </template>
                    <template v-slot:item.delete="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar ml-2">
                            <v-icon class="v-icon-size mr-2 ml-2" small @click="deleteItem(item)" color="red" >delete</v-icon>
                        </v-avatar>
                   </div>
                   </template>

                    <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
               
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
         <v-row justify="center">
             <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
            <v-col cols="12" sm="12" md="12">
            <v-card class="box">
                <v-row dense justify="center">
                <strong>Are you sure want delete ?</strong>
                </v-row>
            </v-card>
             </v-col>
                <v-row dense justify="center">
                    <v-btn class="button" @click="deleteData()">Yes</v-btn>
                    <v-btn class="button" @click="delete_dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            valid: false,
            overlay: false,
             delete_dialog: false,
              delete_id:null,
            errorMsg: {
                name: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            ///////////////////////////////////////////////
            search: "",
            dialog: false,
            headers: [
                {
                    text: "Query Type",
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Edit", value: "action", sortable: false },
                { text: "Delete", value: "delete", sortable: false },
            ],
            query_list: [],
            editedIndex: -1,
            editedItem: {
                queryId: "",
                name: "",
                isactive: true,
            },
           
            defaultItem: {
                queryId: "",
                name: "",
                isactive: true,
            },
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Query Type" : "Edit Query Type";
            },
        },
        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            initializeErrorMsgFalse() {
                this.errorMsg.name = false;
            },

            onLoad() {
                this.overlay = true;
                axios
                    .post("/Query/addQueryType")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.overlay = false;
                            this.query_list = res.data.query_list;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something  Went Wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            }, 
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.query_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
             
            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
             deleteItem(item) {
              this.delete_id = item.id
              this.delete_dialog = true
            },
             async deleteData() {
                 const data = {
                   delete_id:this.delete_id
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/Query/deleteQueryType", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Deleted Successfully..");
                       this.delete_dialog = false;
                       this.onLoad();
                      
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                     
                  
                }
            },
            save() {
                if (this.editedIndex > -1) {
                    //  if (this.isValidated()) {
                    axios
                        .post("/Query/editQueryType", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                Object.assign(this.query_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Query Type Updated Successfully..."); // show snackbar on success
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                    // }
                } else {
                    axios
                        .post("/Query/saveQueryType1", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.query_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Query Type Added Successfully..."); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Query Type Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }, //end of save method.
            isValidated() {
                if (this.editedItem.name) {
                    return true;
                } else {
                    if (!this.editedItem.name) {
                        this.errorMsg.name = true;
                    }

                    return false;
                }
            }, // .....end of isValidated method.
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>